(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/multiply', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/multiply'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.multiply, global.convert);
    global.multiply = mod.exports;
  }
})(this, function (exports, _multiply2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.multiply = undefined;

  var _multiply3 = _interopRequireDefault(_multiply2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces by the multiplication of the former number and the given number.
   * @function
   * @memberof math
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {number} multiplicand The second number in the multiplication.
   * @return {Object} Returns the updated object.
   * @example multiply({ nested: { prop: 333 } }, 'nested.prop', 2) // => { nested: { prop: 666 } }
   * @see {@link https://lodash.com/docs#multiply|lodash.multiply} for more information.
   * @since 0.3.0
   */
  var multiply = (0, _convert.convert)(_multiply3.default);
  exports.multiply = multiply;
  exports.default = multiply;
});